import React from 'react'

const Images=(props)=>{

return  <img src={props.imgsrc} alt="vvv" className="card_img" />;
       
}
export default Images;